// Interfaces
import { ILayoutEmptyProps } from './interfaces'

const LayoutEmpty = ({ children }: ILayoutEmptyProps) => {
  return <>{children}</>
}

export { LayoutEmpty }
